export default __webpack_public_path__ + "static/media/profile_pic.0036f158.jpeg";